import { User } from "../../../mp-database"
import {
  AudienceLocation,
  AudienceLocationAuthPathKeys,
  AudienceLocationNotAuthPathKeys,
  AudienceLocationsWithoutProgram
} from "../../../user-management/pages/ContextHelpManager/EditAnnouncementsModal/constants"
import { AnnouncementsItemType } from "../../../mp-database/contextHelpManager"
import { Roles } from "../../../mp-utils/generic-utils"

export const getAnnouncementLocationByPath = (
  userPage: string,
  announcementLocations: string[]
) => {
  return announcementLocations.find(location => {
    if (!!AudienceLocationNotAuthPathKeys[location]) {
      return AudienceLocationNotAuthPathKeys[location].some((pathKey: string) =>
        userPage.includes(pathKey)
      )
    }

    return AudienceLocationAuthPathKeys[location]?.every((pathKey: string) =>
      userPage.includes(pathKey)
    )
  })
}

export const checkValidityAnnouncement = ({
  announcementTypes,
  announcement,
  user,
  userPage,
  userProgram
}: {
  announcementTypes: string[]
  announcement: AnnouncementsItemType
  user: User
  userPage: string
  userProgram: string
}) => {
  if (!announcementTypes.includes(announcement?.type)) {
    return false
  }

  const currentLocation = getAnnouncementLocationByPath(
    userPage,
    announcement.locations
  )

  if (!currentLocation) {
    return false
  }

  if (!!AudienceLocationNotAuthPathKeys[currentLocation]) {
    return true
  }

  const currentRole = announcement.roles?.find(role => role === user?.role)
  const currentState = announcement.states?.find(state => state === user?.state)

  // Additional check for Teachers и Super Admins
  // If announcement.states is an empty array or not specified, then currentState will be "undefined"
  // This will return "false", even if the user's role matches
  // However, Super Administrators don't have states, so we should not filter by state for them

  const isSuperAdminRole =
    user?.role === Roles.Super_Administrator || user?.role === Roles.ACT_Admin
  const shouldCheckState = !isSuperAdminRole // Don't check state for Super Admins

  const roleCheckFailed = !currentRole && !!announcement.roles?.length
  const stateCheckFailed =
    shouldCheckState && !currentState && !!announcement.states?.length

  if (roleCheckFailed || stateCheckFailed) {
    return false
  }

  if (
    AudienceLocationsWithoutProgram.includes(
      currentLocation as AudienceLocation
    )
  ) {
    return true
  }

  const currentProgram = announcement.programs?.find(
    program => program?.toLowerCase() === userProgram?.toLowerCase()
  )

  if (!currentProgram && !!announcement.programs?.length) {
    return false
  }

  return true
}
